import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { Button } from 'shared/ui'
import { PurgePhiDataStore } from 'pages/settings/pages/doubleOptIn/store/purgePhiDataStore'

export const PurgePhiData = observer(() => {
  const [store] = useState(() => new PurgePhiDataStore())
  const { onOpenModal, loading } = store

  return (
    <Button
      style={{ marginBottom: '-10px' }}
      typeBtn={'contained'}
      contained={'secondary'}
      text={'Purge PHI Data'}
      onClick={onOpenModal}
      loading={loading}
    />
  )
})
